// Predictive gain warnings shown BEFORE the take starts.
// One banner per upcoming cue. Tone: gentle suggestion, always includes the
// "why" (whisper / shout / etc.) so the actor understands the dB change.
//
// These are SUGGESTIONS, not warnings. Color: neutral (blue/grey), never red.
/**
 * Pre-take coaching banner, keyed by the predicted dynamic category of the
 * NEXT cue. Shown for ~3 s before record-arm. The actor can ignore it.
 */
export const PREDICTIVE = {
    whisper: {
        icon: '🤫',
        title: { zh: '耳语场景', en: 'Whisper scene', es: 'Escena susurrada' },
        zh: '下一条很轻。建议靠近 mic,增益 +6 dB。',
        en: 'Next line is whispered. Move closer to the mic, +6 dB gain.',
        es: 'La siguiente toma es susurrada. Acérquese al micrófono y suba la ganancia +6 dB.',
    },
    normal: {
        icon: '💬',
        title: { zh: '平静对话', en: 'Normal dialogue', es: 'Diálogo normal' },
        zh: '下一条是正常对话,保持当前设置。',
        en: 'Standard dialogue volume — keep current settings.',
        es: 'Volumen de diálogo estándar — mantenga la configuración actual.',
    },
    loud: {
        icon: '📣',
        title: { zh: '响度提高', en: 'Raised voice', es: 'Voz elevada' },
        zh: '下一条音量稍大,建议增益 -3 dB,避免触顶。',
        en: 'Next line is louder than dialogue. Trim -3 dB so peaks stay clean.',
        es: 'La siguiente toma es más fuerte que el diálogo. Baje -3 dB para mantener los picos limpios.',
    },
    shout: {
        icon: '🔊',
        title: { zh: '喊叫场景', en: 'Shout scene', es: 'Escena de grito' },
        zh: '下一条是喊叫。后退一拳距离,增益 -6 dB,保护峰值。',
        en: 'Next line is a shout. Back off a fist-length, -6 dB to protect peaks.',
        es: 'La siguiente toma es un grito. Aléjese un puño del micrófono y baje -6 dB para proteger los picos.',
    },
    extreme: {
        icon: '🎭',
        title: { zh: '极端动态', en: 'Extreme dynamics', es: 'Dinámica extrema' },
        zh: '下一条动态极大,又轻又重。建议增益 -3 dB 折中,或分两次录。',
        en: 'Next line swings from soft to loud. Compromise at -3 dB, or split into two takes.',
        es: 'La siguiente toma va de suave a fuerte. Como término medio baje -3 dB, o divídala en dos tomas.',
    },
};
